import { ApplicationConfig, APP_INITIALIZER, ErrorHandler, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { routes } from './app.routes';
import { HttpTimeoutInterceptor } from './_interceptors/http-timeout.interceptor';
import { AuthConfigService } from './services/auth-config.service';
import { SentryErrorHandler } from './services/sentry-integration.service';
import { AuthTokenInterceptor } from './_interceptors/auth-token.interceptor';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authConfigService: AuthConfigService) => () =>
        authConfigService.load(),
      deps: [AuthConfigService],
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'de' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true,
    },
  ],
};
